// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__vbkpc","head":"ProcedureTableInfo_head__1fGW3"};